import React from 'react';
import './App.css'
import Header from './components/Header/Header'
import MainLayout from './components/MainLayout/MainLayout'

function NotificationPanel() {

  return (
    <>
    <div className="main-modal-content">
      <Header/>
      <MainLayout/>
    </div>  
    </>
  )
}

export default NotificationPanel;

